export const checkDateIsZeroValue = (dateString: string | Date): boolean => {
  return dateString === "0001-01-01T00:00:00.000Z";
};
